import { useQuery } from '@tanstack/react-query';
import { getAllServices } from '@/api/services';
import { getAllAnnouncements } from '@/api/announcements';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Briefcase, Megaphone } from 'lucide-react';

export default function AdminDashboard() {
  const { data: services = [] } = useQuery({
    queryKey: ['services'],
    queryFn: () => getAllServices(),
  });

  const { data: announcements = [] } = useQuery({
    queryKey: ['announcements'],
    queryFn: () => getAllAnnouncements(),
  });

  const stats = [
    {
      title: 'Toplam Hizmet',
      value: services.length,
      icon: Briefcase,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Toplam Duyuru',
      value: announcements.length,
      icon: Megaphone,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
  ];

  return (
    <div>
      <h1 className="text-3xl font-bold mb-8">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.title}>
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  {stat.title}
                </CardTitle>
                <div className={`p-2 rounded-lg ${stat.bgColor}`}>
                  <Icon className={`w-5 h-5 ${stat.color}`} />
                </div>
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold">{stat.value}</div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Son Eklenen Hizmetler</CardTitle>
          </CardHeader>
          <CardContent>
            {services.length === 0 ? (
              <p className="text-gray-500">Henüz hizmet eklenmemiş.</p>
            ) : (
              <ul className="space-y-2">
                {services.slice(0, 5).map((service) => (
                  <li key={service.id} className="flex items-center justify-between py-2 border-b last:border-0">
                    <span className="font-medium">{service.title_tr}</span>
                    <span className={`text-xs px-2 py-1 rounded ${service.published ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`}>
                      {service.published ? 'Yayında' : 'Taslak'}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Son Duyurular</CardTitle>
          </CardHeader>
          <CardContent>
            {announcements.length === 0 ? (
              <p className="text-gray-500">Henüz duyuru yok.</p>
            ) : (
              <ul className="space-y-2">
                {announcements.slice(0, 5).map((a: any) => (
                  <li key={a.id} className="flex items-center justify-between py-2 border-b last:border-0">
                    <span className="font-medium">{a.title_tr}</span>
                    <span className={`text-xs px-2 py-1 rounded ${a.published ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`}>
                      {a.published ? 'Yayında' : 'Taslak'}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
